module.exports = __webpack_public_path__ + "media/images/gift_plan/wine-272ad04fcbec7bc6a06ee9cc962aeae6.png";